import React, { useState } from 'react';

import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import PrimaryButton from '../ui/buttons/primaryButton';
import GroupsIcon from '@mui/icons-material/Groups';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import TeamsPanel from './teamsPanel';

// Button + dialog that opens the teams list (add/edit/remove/swap/status)
// without listing teams inline in the calling component.
const ViewTeamsDialog = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <PrimaryButton
        variant="outlined"
        color="primary"
        startIcon={<GroupsIcon />}
        onClick={() => setOpen(true)}>
        View Teams
      </PrimaryButton>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          Teams
          <IconButton onClick={() => setOpen(false)} aria-label="close">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TeamsPanel />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ViewTeamsDialog;
